<div id="routineFormTablet" #routineFormTablet class="modal fade" tabindex="-1">
  <div class="d-flex justify-content-center align-items-center">
    <div class="modal-dialog modal-fullscreen m-4">
      <div class="modal-content">
        <div class="modal-header">
          <h5 style="font-size: 48px" class="fw-bold">RUTINA AUTOMATICA</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <form
            action=""
            [formGroup]="routineForm"
            (ngSubmit)="createRoutine()"
          >
            <div class="d-flex flex-column mb-3">
              <label for="name">Nombre</label>
              <input
                type="text"
                id="name"
                [ngClass]="{
                  'is-invalid': userName.invalid && userName.touched
                }"
                class="custom-input"
                placeholder="Ej: Juan"
                formControlName="userName"
              />

              <div
                *ngIf="userName.invalid && userName.touched"
                class="text-danger"
              >
                Ingrese un nombre válido.
              </div>
            </div>

            <div class="row gx-2">
              <div class="d-flex flex-column col-6">
                <label for="gender">Género</label>
                <select
                  class="form-select custom-input"
                  id="gender"
                  aria-label="Floating label select example"
                  formControlName="gender"
                >
                  <option value="MALE">Hombre</option>
                  <option value="FEMALE">Mujer</option>
                  <option value="OTHER">Otro</option>
                </select>
              </div>

              <div class="d-flex flex-column mb-3 col-6">
                <label for="trainingExperienceMonths">Tiempo entrenando</label>
                <select
                  class="form-select custom-input"
                  id="trainingExperienceMonths"
                  aria-label="Floating label select example"
                  formControlName="trainingExperienceMonths"
                >
                  <option
                    [value]="level.tabletLevel"
                    *ngFor="let level of userExperienceLevels"
                  >
                    {{ level.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="d-flex flex-column mb-3">
              <label for="muscleGroupPriority"
                >Grupo muscular prioritario</label
              >
              <select
                class="form-select custom-input"
                id="muscleGroupPriority"
                aria-label="Floating label select example"
                formControlName="muscleGroupPriority"
              >
                <option
                  [value]="muscleGroup.name"
                  *ngFor="let muscleGroup of muscleGroups"
                >
                  {{ muscleGroup.name }}
                </option>
              </select>
            </div>

            <div class="d-flex flex-column mb-3">
              <label for="expectedTrainingTime"
                >Tiempo disponible para entrenar</label
              >
              <input
                class="form-control custom-input"
                type="phone"
                [ngClass]="{
                  'is-invalid':
                    expectedTrainingTime.invalid && expectedTrainingTime.touched
                }"
                placeholder="Ej: 45"
                formControlName="expectedTrainingTime"
                id="expectedTrainingTime"
              />

              <div
                *ngIf="
                  expectedTrainingTime.invalid && expectedTrainingTime.touched
                "
                class="text-danger"
              >
                Ingrese un tiempo válido en minutos.
              </div>
            </div>
          </form>

          <span>Ejercicios que no puedes / quieres realizar.</span>
          <div class="forbidden-exercises mt-2">
            <div class="" *ngIf="!addingForbiddenExercise">
              <div class="" *ngIf="forbiddenExercisesList.length !== 0">
                Ejercicios quitados
              </div>
              <div
                class="forbidden-exercise d-flex justify-content-between"
                *ngFor="let exercise of forbiddenExercisesList; let i = index"
              >
                <div class="">
                  <span class="fw-bold">{{ i + 1 }}.</span>
                  <span>
                    {{ exercise.name }}
                  </span>
                </div>
                <i
                  class="bi bi-trash-fill"
                  style="color: rgba(199, 4, 4, 0.87)"
                  (click)="removeForbiddenExercise(exercise.id!)"
                ></i>
              </div>

              <div
                class="empty-state-forbidden-exercise"
                *ngIf="forbiddenExercisesList.length == 0"
              >
                No tienes ejercicios quitados.
              </div>

              <button
                class="btn-secondary w-100 mt-3"
                (click)="startAddingForbiddenExercise()"
              >
                +
              </button>
            </div>

            <div class="" *ngIf="addingForbiddenExercise">
              <form action="" [formGroup]="forbiddenExerciseForm">
                <label for="forbiddenMuscleGroup">Grupo Muscular</label>
                <select
                  class="form-select custom-input mb-1"
                  aria-label="Small select example"
                  id="forbiddenMuscleGroup"
                  (change)="onSelectMuscleGroup($event)"
                  formControlName="forbiddenMuscleGroup"
                >
                  <option selected>Selecciona grupo muscular</option>
                  <option
                    [value]="mg.id"
                    (click)="enableExercises()"
                    *ngFor="let mg of muscleGroups"
                  >
                    {{ mg.name }}
                  </option>
                </select>

                <label for="forbiddenExercise">Ejercicio</label>
                <select
                  id="forbiddenExercise"
                  class="form-select custom-input mb-1"
                  aria-label="Small select example"
                  formControlName="forbiddenExercise"
                >
                  <option selected>Selecciona ejercicio</option>
                  <option
                    [value]="exercise.id"
                    *ngFor="let exercise of exercises"
                  >
                    {{ exercise.name }}
                  </option>
                </select>

                <button
                  class="btn-custom-outline w-100"
                  (click)="addForbiddenExercise()"
                  [disabled]="forbiddenExerciseForm.invalid"
                >
                  Agregar ejercicio
                </button>
              </form>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="submit"
            data-bs-dismiss="modal"
            aria-label="Close"
            class="btn-custom fw-bold w-100"
            style="padding: 20px 30px; font-size: 24px"
            [disabled]="routineForm.invalid"
            (click)="createRoutine()"
          >
            Crear mi rutina!
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
